/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 11:19:57
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-07 17:16:55
 * @FilePath: /dbrank_b/src/routes/visualChart/Menu.js
 * @Description: 导航
 */
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React, { Component } from 'react';
import s from './VisualChart.css';
import PropTypes from 'prop-types';
import router from './router';
import Link from '../../components/Link/Link';

class Menu extends Component {
  static propTypes = {
    active: PropTypes.string,
  }
  constructor(props) {
    super(props);
    this.state = {
      toggle: true,
      selected: props.active,
      base: props.active.replace(/([\w\W]+\/).+$/, '$1'),
    }
  }
  
  realPath = (path) => `${this.state.base}${path}`

  onClick = (key) => {
    this.setState({ selected: this.realPath(key) })
  }

  toggle = () => {
    this.setState({
      toggle: !this.state.toggle
    })
  }

  render() {
    const { selected, toggle } = this.state;
    return (
      <div className={classNames(s.menu, {[s.menuCollapsed]: !toggle})}>
        <ul>
          {/* <li>
            <div className={s.submenuTitle}>{this.props.active}</div>
          </li> */}
          {router.map(({ page, title, path }) => (
            <li
              key={path}
              title={title}
              className={classNames({ [s.selected]: selected === this.realPath(path) })}
              onClick={() => this.onClick(path)}>
              <Link className={s.submenuTitle} to={this.realPath(path)} >{page}{toggle ? `-${title}` : ''}</Link>
            </li>
          ))}
        </ul>
        <div className={s.menuToggle} onClick={this.toggle}>{toggle? '收起' : '展开'}</div>
      </div>
    )
  }
}

export default withStyles(s)(Menu);


// WEBPACK FOOTER //
// src/routes/visualChart/Menu.js